var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91129 16.7555C3.12365 11.9678 3.52023 5.88412 3.83823 3.76717C3.9064 3.31339 4.30307 3 4.76193 3H9.19932C9.60823 3 9.97594 3.24895 10.1278 3.62861L11.5401 7.1593C11.7157 7.59837 11.5598 8.10043 11.1663 8.36274L8.89382 9.87773C8.89382 9.87773 8.89382 11.8428 10.8589 13.8079C12.824 15.7729 14.789 15.7729 14.789 15.7729L15.4412 14.4685C15.6376 14.0758 16.067 13.8571 16.5001 13.9293L20.8311 14.6511C21.3133 14.7315 21.6667 15.1487 21.6667 15.6375V19.9048C21.6667 20.3637 21.3534 20.7603 20.8996 20.8285C18.7826 21.1465 12.6989 21.5431 7.91129 16.7555Z",
    fill: "#D9E5F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFill);
export default __webpack_public_path__ + "static/media/call-fill.0bc0ff3ba8330b1a64cca18212422a9c.svg";
export { ForwardRef as ReactComponent };